import React, { useMemo } from 'react';
import { Card, Modal } from 'antd';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { toCurrency, toRate } from 'utils/utils';
import { useQuery } from 'react-query';
import { getVarInterestDetailByCalcId } from 'services/clientInvoice';

type CiVarInterestRateDetailModalProps = {
  onCancel: () => void;
  visible: boolean;
  currcode: string;

  calcid: number;
};

const CiVarInterestRateDetailModal = (
  props: CiVarInterestRateDetailModalProps
) => {
  const { currcode, calcid } = props;

  const { data: varInterestRateDetailList, isLoading } = useQuery(
    ['getVarInterestByCiid', calcid],
    () =>
      getVarInterestDetailByCalcId({ ciid: Number(calcid) }).then((res) => {
        return res.list || [];
      }),
    { enabled: !!calcid }
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'order',
        width: '40px',
        render: (val, record, index) => index + 1,
      },

      {
        dataIndex: 'calcdetailstartdate',
        width: '100px',
      },
      {
        dataIndex: 'calcdetailenddate',
        width: '100px',
      },
      {
        dataIndex: 'calcdetailnbdays',
        width: '100px',
      },
      {
        dataIndex: 'ratevalueref',
        width: '100px',
        render: (val, record) => toRate(val),
      },
      {
        dataIndex: 'ratespread',
        width: '100px',
        render: (val, record) => toRate(val),
      },
      {
        dataIndex: 'calcinterestrate',
        width: '100px',
        render: (val, record) => toRate(val),
      },

      {
        dataIndex: 'calcbasis',
        width: '100px',
      },

      {
        dataIndex: 'amountbasis',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
      {
        dataIndex: 'interestamount',
        width: '100px',
        render: (val, record) => toCurrency(val, currcode),
      },
    ],

    []
  );

  return (
    <Modal
      visible={props.visible}
      onCancel={props.onCancel}
      width={1400}
      className="fitcontent"
      footer={null}
    >
      <Card>
        <DataGrid
          titleComcode="CiVarInterestRateDetail"
          columns={columns}
          dataSource={varInterestRateDetailList}
          rowKey="cisid"
          scroll={{ x: 1200, y: 360 }}
          hideFilters
          isLoading={isLoading}
          pagination={false}
        />
      </Card>
    </Modal>
  );
};

export default CiVarInterestRateDetailModal;
